export enum USER_PROFILE_TYPE {
  CN = 'CN',
  LEADER = 'LEADER',
  GDN = 'GDN',
}
